import { ChevronLeftIcon, ChevronRightIcon } from 'flowbite-react'
import { cn } from '@/utilities/ui'

type PaginationProps = {
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
}

const VISIBLE_PAGE_COUNT = 3

const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) {
    return null
  }

  let visiblePagesStart = Math.max(currentPage - 1, 1)
  const visiblePagesEnd = Math.min(visiblePagesStart + VISIBLE_PAGE_COUNT - 1, totalPages)
  visiblePagesStart = Math.max(visiblePagesEnd - VISIBLE_PAGE_COUNT + 1, 1)
  const visiblePages = Array.from(
    { length: visiblePagesEnd - visiblePagesStart + 1 },
    (_, i) => visiblePagesStart + i,
  )
  const showLeftEllipsis = visiblePagesStart > 1
  const showRightEllipsis = visiblePagesEnd < totalPages

  return (
    <div className="flex w-full justify-center mb-8">
      <div className="flex justify-center items-center gap-2">
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={cn('px-4 py-4 text-black disabled:opacity-50 font-bold')}
        >
          <ChevronLeftIcon />
        </button>

        {showLeftEllipsis && <span className="px-1 opacity-50">...</span>}

        {visiblePages.map((page) => (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={cn(
              'size-10 rounded-full transition-colors duration-200',
              page === currentPage ? 'font-bold' : 'opacity-50',
            )}
          >
            {page}
          </button>
        ))}

        {showRightEllipsis && <span className="px-1 opacity-50">...</span>}

        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={cn('px-4 py-4 text-black disabled:opacity-50 font-bold')}
        >
          <ChevronRightIcon />
        </button>
      </div>
    </div>
  )
}

export default Pagination
